// extracted by mini-css-extract-plugin
module.exports = {"future-section":"PlatformsFuture_future-section__VPeHO","image-wrapper":"PlatformsFuture_image-wrapper__KPDdr","future_text":"PlatformsFuture_future_text__p1VJV"};